import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { WelcomePage } from "../welcome/welcome";
import { AuthProvider } from "../../providers/authservice/auth";
import { AngularFireDatabase } from "angularfire2/database";
//import { AngularFireOfflineDatabase } from "angularfire2-offline";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
import { HomePage } from "../home/home";
import { OpenTablesPage } from "../opentables/opentables";

@Component({
  selector: 'page-restaurantslist',
  templateUrl: 'restaurantslist.html',
})
export class RestaurantslistPage implements OnInit {

  @ViewChild('listAnimate') listAnimate;
  isLoading: boolean = false;
  public listOfRestaurents: any = [];
  public items: any = [];
  defaultImage: string = 'assets/icon/placeholder.png';
  lazyLoadImage: string = 'assets/icon/res.png';
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public authProvider: AuthProvider,
    public af: AngularFireDatabase,
    //  public aof: AngularFireOfflineDatabase,
    public animateService: SmartanimationProvider,

  ) {

  }
  ngOnInit() {
    this.af.list('/restaurants').snapshotChanges().map(changes => {
      return changes.map(c => ( { key: c.payload.key, ...c.payload.val()}));
    }).subscribe((response) => {
      for( var i = response.length-1; i--;){
        if ( response[i].key === '-1') response.splice(i, 1);
        }
      this.listOfRestaurents = response;
      this.items=response;
      console.log(this.listOfRestaurents);
      // console.log(JSON.stringify(this.listOfRestaurents));
      this.isLoading = true;
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RestaurantslistPage');
  }

  welcomePage() {
    this.navCtrl.setRoot(WelcomePage,{initiator:'restaurantList'});
  }
  
  goToWaiterPage()
  {
    this.navCtrl.setRoot(OpenTablesPage,{initiator:'restaurantList'});
  }
  // image loading indicator


  showResturents(resturentObj: any) {
    console.log('click');
    console.log(resturentObj);
    if (localStorage.getItem('UserId'))
      this.navCtrl.setRoot(HomePage, { resturenData: resturentObj });
    else
      this.navCtrl.setRoot(HomePage, { resturenData: resturentObj });
  }

    filterRestaurants(ev: any){
    this.listOfRestaurents=this.items;
    let val = ev.target.value;
    
    if (val && val.trim() != '') {
      this.listOfRestaurents = this.listOfRestaurents.filter((item) => {
         return (item.Address.res_name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
      
    }
   }

  ionViewWillEnter() {
   this.animateService.smartAnimation().setType('fadeIn').show(this.listAnimate.nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/pages/restaurantslist/restaurantslist.ts